module.exports = __webpack_public_path__ + "static/media/moraine-33.89aa1393.jpg";